import React from "react";

export function Disclaimer({ compact = false, dataTestId = "global-disclaimer", variant = "full" }) {
  if (variant === "auto") {
    return (
      <div
        data-testid={dataTestId}
        className={`legal-disclaimer ${compact ? "text-xs" : ""}`}
      >
        <p className="font-medium text-gray-900 mb-1">Aviso legal — Variante automatizada sin revisión humana.</p>
        <p>
          <strong>Este documento será generado por inteligencia artificial sin revisión humana experta.</strong>{" "}
          JustSapiens Procure NO garantiza la corrección legal del contenido. Este documento NO constituye
          asesoría jurídica concluyente, NO reemplaza el concepto de un abogado titulado, ni sustituye
          la decisión del ordenador del gasto, del comité asesor evaluador, ni del comité de contratación
          de la entidad. <strong>El usuario asume total responsabilidad por el uso de este documento.</strong>{" "}
          La responsabilidad disciplinaria, fiscal y penal sobre el proceso contractual permanece en cabeza
          de los servidores públicos competentes. Información tratada conforme a la Ley 1581 de 2012 y a la
          Política de Tratamiento de Datos de JustSapiens.
        </p>
      </div>
    );
  }

  return (
    <div
      data-testid={dataTestId}
      className={`legal-disclaimer ${compact ? "text-xs" : ""}`}
    >
      <p className="font-medium text-gray-900 mb-1">Aviso legal.</p>
      <p>
        JustSapiens Procure entrega insumos de apoyo basados en inteligencia
        artificial con revisión humana experta para procesos de contratación
        pública en Colombia. <strong>Los diagnósticos y documentos generados no constituyen
        asesoría jurídica concluyente, no reemplazan el concepto de un abogado titulado,
        ni sustituyen la decisión del ordenador del gasto, del comité asesor evaluador,
        ni del comité de contratación de la entidad.</strong>{" "}
        Toda entrega de Diagnóstico y Kit Documental requiere revisión humana experta previa
        a su descarga. La responsabilidad disciplinaria, fiscal y penal sobre el
        proceso contractual permanece en cabeza de los servidores públicos
        competentes. Información tratada conforme a la Ley 1581 de 2012 y a la
        Política de Tratamiento de Datos de JustSapiens.
      </p>
    </div>
  );
}
